import * as React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import uncPolyLargeLogo from '../../assets/images/unc poly logo-large-01.svg';
import { myWatchListData } from '../../Shared/MyWatchListAndCollectionsData';

export interface IMyWatchListProps {
}

export function MyWatchList(props: IMyWatchListProps) {

    const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
    const abbreviateNumber = (number: any) => {
        const tier = Math.log10(Math.abs(number)) / 3 | 0;
        if (tier === 0) return number;
        const suffix = SI_SYMBOL[tier];
        const scale = Math.pow(10, tier * 3);
        const scaled = number / scale;
        return scaled.toFixed(1) + suffix;
    }




    return (
        <div className="relative overflow-hidden">
            <div className="
        pt-[64px]
        sm:max-w-[570px] sm:pt-[80px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px]
        mx-auto xs:mt-6 sm:mt-10 md:mt-24 pb-28 md:pb-24 px-4 my_watch_list_main_box">
                <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white text-left">My Watchlist</h1>

                <div className="mt-5 overflow-auto w-full">

                    <ScrollContainer>
                        <div className="
                       w-[870px]
                        xl:w-full
                    ">
                            <div className="grid grid-cols-8 justify-start items-center bg-[#dcdcdc] dark:bg-[#201753] p-4 mb-2">
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium col-span-2">Collection</p>
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium">Floor price</p>
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium">7d Volume</p>
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium">24h %</p>
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium">7d %</p>
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium">Owners</p>
                                <p className="text-cusBlack dark:text-white text-left text-base whitespace-nowrap xl:text-xl font-semibold dark:font-medium">Items</p>
                            </div>

                            {myWatchListData.map(data =>
                                <div key={data.id}>
                                    <div className="grid grid-cols-8 justify-start items-center py-3">
                                        <div className="flex justify-start items-center col-span-2">
                                            <div className="w-11 h-11 rounded-full overflow-hidden">
                                                <img src={data.logo} alt="" className="w-full h-full" />
                                            </div>
                                            <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap ml-5">{data.name}</p>
                                        </div>

                                        <div className="flex justify-start items-center">
                                            <svg className="w-[8px] lg:w-[13px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                            </svg>

                                            <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap ml-3">{data.floorPrice.toFixed(2)}</p>
                                        </div>

                                        <div className="flex justify-start items-center">
                                            <svg className="w-[8px] lg:w-[13px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                            </svg>

                                            <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap ml-3">{data.volume.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                        </div>

                                        <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap">{data.hours24}</p>
                                        <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap">{data.day}</p>
                                        <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap">{data.ownersNum}</p>
                                        <p className="text-cusBlack dark:text-white dark:font-semibold font-bold text-xs xl:text-base whitespace-nowrap">{abbreviateNumber(data.items)}</p>
                                    </div>
                                    <div className="border-b border-[#B7B7B7] dark:border-[#201753]"></div>
                                </div>)}
                        </div>


                    </ScrollContainer>


















                </div>

                <div className="fixed xs:hidden md:block
            xs:w-[367px] xs:right-[-119px] xs:bottom-[-20px]
            md:w-[397px] md:right-[-139px] md:bottom-[-29px]
            xl:w-[479px] xl:right-[-162px] xl:bottom-[-31px]
            3xl:w-[550px] 3xl:right-[-177px] 3xl:bottom-[-41px] select-none z-0
            ">
                    <img src={uncPolyLargeLogo} alt="" className="w-full h-full" />
                </div>
            </div>
        </div>
    );
}
